import qs from 'qs'

const getSearch = (location) => {
  try {
    return qs.parse(decodeURIComponent(location.search.replace('?', '')), {
      arrayFormat: 'brackets',
      decoder(value) {
        if (/^(\d+|\d*\.\d+)$/.test(value)) {
          return parseFloat(value)
        }

        const keywords = {
          true: true,
          false: false,
          null: null,
          undefined: undefined,
        }
        if (value in keywords) {
          return keywords[value]
        }

        return value
      },
    })
  } catch (error) {
    return {}
  }
}
export const search = getSearch

export default function useLocationFilters(location) {
  const searchObject = getSearch(location)

  const filtersPayload = []
  for (const key in searchObject) {
    filtersPayload.push({ fieldName: key, value: searchObject[key] })
  }

  return filtersPayload
}
